import React from 'react';
import { Grid, TextField, Typography, Box } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

const BasicInfoSection = ({ formData, handleChange, setFormData, errors, patient }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 1: Patient Details
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="UHID NO"
            fullWidth
            name="uhid_no"
            value={formData.uhid_no || ''}
            InputProps={{ readOnly: true }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Patient Name"
            fullWidth
            value={patient.name || ''}
            InputProps={{ readOnly: true }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Date of Birth"
            fullWidth
            name="date_of_birth"
            type="date"
            value={formData.date_of_birth || ''}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            variant="filled"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="caption" sx={{ color: errors.emergency_contact ? '#008080' : 'text.secondary', ml: 1 }}>
            Emergency Contact Number *
          </Typography>
          <PhoneInput
            country={'in'}
            value={formData.emergency_contact || ''}
            onChange={(value) => setFormData(prev => ({ ...prev, emergency_contact: value }))}
            enableSearch
            inputProps={{ name: 'emergency_contact', required: true }}
            containerStyle={{ width: '100%', marginTop: '4px' }}
            inputStyle={{ width: '100%', height: '56px', borderRadius: '4px' }}
            buttonStyle={{ height: '56px', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }}
          />
          {errors.emergency_contact && (
            <Typography variant="caption" color="error" sx={{ ml: 1 }}>{errors.emergency_contact}</Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicInfoSection;
